import { useQuery } from "@apollo/client";
import { GET_APPLICANT_INTERVIEW_SCHEDULING } from "graphql/queries/interviewSchedulingSettings";

const useApplicantInterviewSettings = ({ show, applicationId }) => {
  const { data, loading, error } = useQuery(GET_APPLICANT_INTERVIEW_SCHEDULING, {
    variables: { missionRoleApplicantId: applicationId },
    skip: !show || !applicationId,
    fetchPolicy: "network-only",
  });

  return {
    setting: data?.interviewSchedulingSetting,
    requests: data?.interviewSchedulingRequests || [],
    loading,
    error,
  };
};

export default useApplicantInterviewSettings;
